﻿// Import modal
import ModalHeaderSearch from './components/modals/HeaderSearch.vue';

const headerSearchApp = {
    components: {
        ModalHeaderSearch,
    },
    methods: {
        openModal(modalName, props = {}) {
            if (!modalName) return;
            const component = this.$options.components[modalName];

            if (component) {
                this.$store.commit('openModal',
                    {
                        component: component,
                        props: props,
                    }
                );
            }
        },
    },
}

export default headerSearchApp;
